import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useTeam } from "@/lib/team";

const Ctx = createContext({ items: [], unread: 0, reload: () => {} });

// Assistant inbox (owner nudges): polled every minute and when the app comes back into view.
export function InboxProvider({ children }) {
  const { isAssistant } = useTeam();
  const [state, setState] = useState({ items: [], unread: 0 });
  const reload = useCallback(() => {
    if (!isAssistant) return;
    api.get("/inbox").then(({ data }) => setState({ items: data.nudges, unread: data.unread })).catch(() => {});
  }, [isAssistant]);
  useEffect(() => {
    reload();
    if (!isAssistant) return undefined;
    const t = setInterval(() => { if (!document.hidden) reload(); }, 5 * 60000);
    const vis = () => document.visibilityState === "visible" && reload();
    document.addEventListener("visibilitychange", vis);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", vis); };
  }, [isAssistant, reload]);
  return <Ctx.Provider value={{ ...state, reload }}>{children}</Ctx.Provider>;
}

export const useInbox = () => useContext(Ctx);
